import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class StoreManagementService {
  private readonly roles$: Subject<any> = new Subject<any>();
  private readonly userInfo$: Subject<any> = new Subject<any>();

  get roles() {
    return this.roles$.asObservable();
  }
  setRoles(value) {
    this.roles$.next(value);
  }

  get userInfo() {
    return this.userInfo$.asObservable();
  }
  setUserInfo(value) {
    this.userInfo$.next(value);
  }

  getUserInSession() {
    let profileInSession = JSON.parse(sessionStorage.getItem("profile"));
    this.userInfo.subscribe((userInfo) => {
      profileInSession = userInfo
        ? userInfo
        : JSON.parse(sessionStorage.getItem("profile"));

      return profileInSession;
    });
    return profileInSession;
  }

  constructor() {}
}
